// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "e99b23de386e0a56","396": "13969075b1d6d6be","460": "f69f2946cc715e82","917": "4a32ee079e4835c0","985": "dc4752053693aa90",}[chunkId] + ".chunk.js"
}